"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REWARDS = void 0;
exports.asTypedRewardPrototype = asTypedRewardPrototype;
exports.asTypedRewardInstance = asTypedRewardInstance;
const TEXT_1 = __importDefault(require("./TEXT"));
const TREMENDOUS_REWARD_1 = __importDefault(require("./TREMENDOUS_REWARD"));
const POST_SLACK_MESSAGE_1 = __importDefault(require("./POST_SLACK_MESSAGE"));
const CREATE_QUEST_1 = __importDefault(require("./CREATE_QUEST"));
const RUN_QUEST_SCRIPT_1 = __importDefault(require("./RUN_QUEST_SCRIPT"));
/**
 * Reward Definitions for each RewardType.
 *
 * Definitions assist with typing of config and data Json Objects as well as validations.
 */
exports.REWARDS = {
    TEXT: TEXT_1.default,
    TREMENDOUS_REWARD: TREMENDOUS_REWARD_1.default,
    POST_SLACK_MESSAGE: POST_SLACK_MESSAGE_1.default,
    CREATE_QUEST: CREATE_QUEST_1.default,
    RUN_QUEST_SCRIPT: RUN_QUEST_SCRIPT_1.default,
};
function asTypedRewardPrototype(reward) {
    return reward;
}
function asTypedRewardInstance(reward) {
    return reward;
}
//# sourceMappingURL=index.js.map